<template>
  <div class="rechargerecordNew">
    <div class="section">
      <!-- <div class="list-header">
        <div class="title">{{$t('recharge.Recharge_List')}}</div>
      </div> -->
      <div class="search">
        <div>
          <!-- 充值状态 -->
          <span class="search-label">{{ $t('recharge.Recharge_status') }}</span>
          <el-select v-model="searchRecharge.payStatus" @change="getData(true)" :placeholder="this.$t('header.pleaseSelect')"
            size="small" popper-class="select-search-recharge" class="selectClearNew" clearable>
            <el-option v-for="(val, key) in rechargeStatus" :key="key" :label="val.label" :value="key"
              style="display:flex;align-items:center;">
              <i style="width:10px;height:10px;margin-right:8px;" :class="`status-${val.class}`"></i>
              <span class="select-label">{{ val.label }}</span>
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <!-- showSearch = true; -->
        <el-button class="button button-solid" @click.stop="showSearchBtn">
          <i class="el-icon-search"></i>
        </el-button>
        <!-- v-clickoutside="closeSearch2" -->
        <div class="search-alert" v-show="showSearch">
          <!-- :placeholder="$t('recharge.pn')" -->
          <!-- v-model="inputText" -->
          <div class="searchDiv">
            <el-input class="searchAll" ref="iptFocus" v-model.trim="searchRecharge.pn" @keyup.enter.native="getData(true)"
              :placeholder="this.$t('datalogger.Datalogger_PN')" clearable>
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <span class="search-device" @click="getData(true)">{{ $t('recharge.Search') }}</span>
            <span class="search-hide" @click="closeSearch">{{ $t('datalogger.cancel') }}</span>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <el-table class="tablemain tableloding" v-loading="isLoading" element-loading-spinner="el-icon-loading"
        :data="rechargeList" stripe border height="100%"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" :empty-text="$t('account.nodata')">
        <el-table-column prop="createTime" :show-overflow-tooltip="true" :label="this.$t('recharge.Time')">
        </el-table-column>
        <el-table-column prop="orderNo" :label="this.$t('recharge.Order_Number')"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column  :label="this.$t('recharge.Datalogger_PN')" :show-overflow-tooltip="true">
          <!-- <template slot-scope="scope">
            <template v-if="scope.row.pn && scope.row.pn.includes(',')">
              <el-tooltip class="item" effect="dark" :content="scope.row.pn" placement="top-start">
                <span>{{scope.row.pn.split(',')[0]+`(${scope.row.pn.split(',').length})`}}</span>
              </el-tooltip>
            </template>
            <span v-else>{{scope.row.pn}}</span>
          </template> -->
            <template slot-scope="scope">
            
            <el-tooltip v-if="scope.row.pns.length>1" class="item" effect="dark" :content="scope.row.pns.join(',')" placement="top-start">
              <span >{{scope.row.pns[0]+`(${scope.row.pns.length})`}}</span>
           </el-tooltip>

            <span v-else>{{scope.row.pns[0]}}</span>
          </template>
        </el-table-column>
        <el-table-column  :label="this.$t('recharge.CCID')" :show-overflow-tooltip="true"
          min-width="80px">
          <!-- <template slot-scope="scope">
            <template v-if="scope.row.ccid && scope.row.ccid.includes(',')">
              <el-tooltip class="item" effect="dark" :content="scope.row.ccid" placement="top-start">
                <span>{{scope.row.ccid.split(',')[0]+`(${scope.row.ccid.split(',').length})`}}</span>
              </el-tooltip>
            </template>
            <span v-else>{{scope.row.ccid}}</span>
          </template> -->
            <template slot-scope="scope">
                
            <el-tooltip v-if="scope.row.ccIds.length>1" class="item" effect="dark" :content="scope.row.ccIds.join(',')" placement="top-start">
              <span >{{scope.row.ccIds[0]+`(${scope.row.ccIds.length})`}}</span>
           </el-tooltip>

            <span v-else>{{scope.row.ccIds[0]}}</span>
          </template>
          </el-table-column>
        <el-table-column prop="months" :label="this.$t('recharge.Rcharge_Month')"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payAmount" :label="this.$t('recharge.Recharge_money')"
          :show-overflow-tooltip="true">
            <template slot-scope="scope">
                <span>{{scope.row.payChannel==5? '$' : '￥'}}{{ scope.row.payAmount }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="status" :label="this.$t('recharge.rechargeStatus')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.payStatus !== undefined"
              :class="`color-${rechargeStatus[scope.row.payStatus].class}`">{{ rechargeStatus[scope.row.payStatus] ?
                rechargeStatus[scope.row.payStatus].label : '' }}</span>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
                <div style="line-height: 32px">{{$t('message.nodata')}}</div></div> -->
      </el-table>
      <!-- 分页 -->
      <!-- v-show="paginationPay" -->
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span class="" style="margin-left:16px;"></span>
        <el-pagination class="pagination" popper-class="select-page" background @size-change="getData(true)"
          @current-change="() => getData()" :current-page.sync="pagination.currentPage" :page-sizes="[10, 15, 20, 30]"
          :page-size.sync="pagination.pagesize" layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      searchRecharge: {
        pn: '',
        payStatus: '',
      },
      isLoading: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      },
      rechargeList: [],
      // rechargeList:[
      //   {
      //     "createTime": '2021-01-01',
      //     "orderNo": '100001',
      //     "status": 0,
      //   },
      //   {
      //     "createTime": '2021-01-02',
      //     "orderNo": '100002',
      //     "status": 1,
      //   }
      // ],
      // 订单状态列表
      rechargeStatus: {
        0: {
          class: "offline",
          label: this.$t('rosRecharge.unpaid')
        },
        1: {
          class: "pending",
          label: this.$t('rosRecharge.paying')
        },
        2: {
          class: "standby",
          label: this.$t('rosRecharge.paid')
        },
        3: {
          class: "fault",
          label: this.$t('rosRecharge.paymentFailed')
        },
        4: {
          class: "refund",
          label: this.$t('rosRecharge.refunded')
        },
        5: {
          class: "cancel",
          label: this.$t('rosRecharge.cancelled')
        },
        6: {
          class: "normal",
          label: this.$t('rosRecharge.rechargeSuccess')
        },
        7: {
          class: "warning",
          label: this.$t('rosRecharge.rechargeFailed')
        }
      },
      // paginations: {
      //   currentPage: 1,
      //   pagesize: 15,
      //   total: 0
      // },
      showSearch: false, // 搜索弹出
      inputText: '', // 搜索内容
      paginationPay: false,
      emptyTextElse: false,
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    //获取充值记录
    getData (reset) {
      this.paginationPay = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        current: this.pagination.currentPage - 1,
        size: this.pagination.pagesize,
        ...this.searchRecharge
      };
      this.isLoading = true;
      this.$request
        .postDEVMicroservices("/ros/api/flow/order/pub/page", param)
        .then(res => {
          if (res.code == 0) {
            this.rechargeList = res.data.records;
            this.pagination.total = res.data.total;
            if (this.pagination.total > this.pagination.pagesize) {
              this.paginationPay = true
            }
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.emptyTextElse = true;
            this.rechargeList = [];
            this.pagination.total = 0;
          }
          this.isLoading = false;
        });
    },
    // 关闭搜索框
    closeSearch () {
      this.showSearch = false;
      this.searchRecharge.pn = '';
      this.searchRecharge.payStatus = '';
      this.getData();
    },
    // closeSearch2() {
    //   this.searchRecharge.pn = '';
    //   this.searchRecharge.payStatus = '';
    //   if (this.showSearch) {
    //     this.getData();
    //   }
    //   this.showSearch = false;
    // },
    showSearchBtn () {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      })
    }
  }
}
</script>
<style lang="less" scoped>
.rechargerecordNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 110px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {

          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7B8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: 'X'
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}

// 订单状态
.color-ok {
  color: rgb(73, 222, 255);
}

.color-no {
  color: rgb(123, 131, 149);
}
</style>